const NODE_ENV = process.env.NODE_ENV || 'development';

const SYS_API = process.env.VUE_APP_SYS_URL || 'http://192.168.7.241:31013/sys';
const CORE_API = process.env.VUE_APP_CORE_URL || 'http://192.168.7.241:31013/core';
export default {
    NODE_ENV,SYS_API,CORE_API
};